import { render, staticRenderFns } from "./RemindersComponent.vue?vue&type=template&id=2c95e605&scoped=true"
import script from "./RemindersComponent.vue?vue&type=script&lang=js"
export * from "./RemindersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95e605",
  null
  
)

export default component.exports